(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Fetch matching store products while the customer types. */
  (() => {
    if (customElements.get('tp-live-search')) return;

    class TPLiveSearch extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[name="q"]');
        this.form = this.querySelector('form');
        this.panel = this.querySelector('.tp-search-results');
        this.list = this.querySelector('[role="listbox"]');
        this.message = this.querySelector('[data-search-message]');
        this.status = this.querySelector('[data-search-status]');
        this.allLink = this.querySelector('[data-search-all]');
        this.resetButton = this.querySelector('[type="reset"]');
        this.details = this.closest('details');
        this.isOpen = false;
        this.version = 0;
        this.resultsQuery = '';
        this.selectedIndex = -1;
        this.events = new AbortController();
        const options = { signal: this.events.signal };

        this.input.addEventListener('input', (event) => {
          if (!event.isComposing) this.queueSearch();
        }, options);
        this.input.addEventListener('compositionend', () => this.queueSearch(), options);
        this.input.addEventListener('focus', () => this.queueSearch(), options);
        this.addEventListener('pointerenter', () => {
          if (!this.isOpen) this.queueSearch();
        }, options);
        this.addEventListener('keydown', (event) => this.onKeydown(event), options);
        this.addEventListener('focusout', () => {
          clearTimeout(this.blurTimer);
          this.blurTimer = setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
          }, 0);
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) this.close();
        }, options);
        this.details.addEventListener('toggle', () => {
          if (!this.details.open) this.close();
        }, options);
        this.form.addEventListener('reset', (event) => {
          event.preventDefault();
          this.input.value = '';
          this.resultsQuery = '';
          this.resetButton.classList.add('hidden');
          this.close();
          this.input.focus();
        }, options);
        this.form.addEventListener('submit', (event) => {
          if (!this.input.value.trim()) event.preventDefault();
        }, options);
        window.addEventListener('resize', () => {
          if (this.isOpen) this.resizePanel();
        }, options);
      }

      disconnectedCallback() {
        this.close();
        clearTimeout(this.blurTimer);
        this.events.abort();
      }

      cancelRequest() {
        clearTimeout(this.timer);
        this.request?.abort();
        this.version += 1;
      }

      queueSearch() {
        this.cancelRequest();
        const query = this.input.value.trim();
        this.resetButton.classList.toggle('hidden', !this.input.value.length);
        if (!query || !this.details.open) {
          this.close();
          return;
        }
        if (this.resultsQuery === query) {
          this.open();
          return;
        }
        this.panel.hidden = true;
        this.isOpen = false;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        const version = this.version;
        this.timer = setTimeout(() => this.search(query, version), 200);
      }

      async search(query, version) {
        this.request = new AbortController();
        this.resultsQuery = '';
        this.list.replaceChildren();
        this.selectedIndex = -1;
        this.updateAllLink(query);
        this.setMessage('Searching products…');
        this.list.setAttribute('aria-busy', 'true');
        this.open();
        try {
          const url = new URL(this.dataset.suggestUrl, window.location.origin);
          if (!url.pathname.endsWith('.json')) url.pathname += '.json';
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '6');
          url.searchParams.set('resources[options][unavailable_products]', 'last');
          const response = await fetch(url.toString(), { signal: this.request.signal });
          if (!response.ok) throw new Error('Product search unavailable');
          const data = await response.json();
          if (version !== this.version || !this.details.open) return;
          const products = data.resources?.results?.products;
          if (!Array.isArray(products)) throw new Error('Invalid product search response');
          this.render(products);
          this.resultsQuery = query;
          const count = this.list.children.length;
          this.setMessage(count ? '' : 'No matching products found.');
          this.status.textContent = count ? `${count} product suggestions available.` : 'No matching products found.';
          this.list.removeAttribute('aria-busy');
          this.open();
        } catch (error) {
          if (error.name === 'AbortError' || version !== this.version) return;
          this.list.removeAttribute('aria-busy');
          this.setMessage('Suggestions are temporarily unavailable. Use search to see all results.');
        }
      }

      render(products) {
        const fragment = document.createDocumentFragment();
        products.forEach((product, index) => {
          const url = this.safeURL(product.url);
          if (!url || url.origin !== window.location.origin) return;
          const item = document.createElement('li');
          item.id = `${this.list.id}-${index}`;
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', 'false');
          const link = document.createElement('a');
          link.className = 'tp-search-product';
          link.href = url.href;
          link.tabIndex = -1;
          const imageURL = this.safeURL(product.featured_image?.url || product.image);
          if (imageURL) {
            imageURL.searchParams.set('width', '120');
            const image = document.createElement('img');
            image.src = imageURL.href;
            image.alt = '';
            image.width = 52;
            image.height = 62;
            link.append(image);
          }
          const title = document.createElement('span');
          title.textContent = product.title;
          link.append(title);
          item.append(link);
          fragment.append(item);
        });
        this.list.replaceChildren(fragment);
      }

      safeURL(value) {
        if (!value || typeof value !== 'string') return null;
        try {
          const url = new URL(value, window.location.origin);
          return ['https:', 'http:'].includes(url.protocol) ? url : null;
        } catch { return null; }
      }

      updateAllLink(query) {
        const url = new URL(this.form.action);
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
        this.allLink.href = url.toString();
        this.allLink.textContent = `View all results for “${query}”`;
      }

      setMessage(text) {
        this.message.textContent = text;
        this.message.hidden = !text;
        if (text) this.status.textContent = text;
      }

      resizePanel() {
        const available = window.innerHeight - this.panel.getBoundingClientRect().top - 16;
        this.panel.style.maxHeight = `${Math.max(0, Math.min(420, available))}px`;
      }

      open() {
        this.panel.hidden = false;
        this.isOpen = true;
        this.input.setAttribute('aria-expanded', 'true');
        this.resizePanel();
      }

      close() {
        this.cancelRequest();
        this.panel.hidden = true;
        this.isOpen = false;
        this.selectedIndex = -1;
        this.list.removeAttribute('aria-busy');
        this.list.querySelector('[aria-selected="true"]')?.setAttribute('aria-selected', 'false');
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
      }

      onKeydown(event) {
        if (event.isComposing) return;
        if (event.key === 'Escape' && this.isOpen) {
          event.preventDefault();
          event.stopPropagation();
          this.close();
          return;
        }
        if (event.target !== this.input) return;
        if (event.key === 'Enter' && this.isOpen && this.selectedIndex >= 0) {
          event.preventDefault();
          this.list.children[this.selectedIndex]?.querySelector('a')?.click();
          return;
        }
        if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
        const items = Array.from(this.list.children);
        if (!items.length || this.resultsQuery !== this.input.value.trim()) return;
        event.preventDefault();
        this.open();
        if (this.selectedIndex >= 0) items[this.selectedIndex].setAttribute('aria-selected', 'false');
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        this.selectedIndex = this.selectedIndex < 0
          ? (direction > 0 ? 0 : items.length - 1)
          : (this.selectedIndex + direction + items.length) % items.length;
        const selected = items[this.selectedIndex];
        selected.setAttribute('aria-selected', 'true');
        this.input.setAttribute('aria-activedescendant', selected.id);
        selected.scrollIntoView({ block: 'nearest' });
      }
    }

    customElements.define('tp-live-search', TPLiveSearch);
  })();
  /* ── Announcement Bar Dismiss ── */
  (function() {
    var announcementBar = document.getElementById('tp-announcement-bar');
    var closeBtn = document.getElementById('tp-announcement-close');
    if (announcementBar && closeBtn) {
      if (sessionStorage.getItem('tp-announcement-closed')) {
        announcementBar.style.display = 'none';
      }
      closeBtn.addEventListener('click', function() {
        announcementBar.style.display = 'none';
        sessionStorage.setItem('tp-announcement-closed', '1');
      });
    }
  })();

  /* ── Sticky Header + Glass Effect ── */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.wrapper = document.getElementById('tp-header-wrapper');

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('tp-live-search, predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.wrapper) {
        this.wrapper.classList.toggle('tp-scrolled', scrollTop > 50);
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ═══════════════════════════════════════════════════════════════
     GLOBAL WISHLIST MANAGER
     ═══════════════════════════════════════════════════════════════ */
  (function() {
    'use strict';

    var TPWishlist = {
      storageKey: 'wishlist',

      getWishlist: function() {
        try {
          var data = localStorage.getItem(this.storageKey);
          return data ? JSON.parse(data) : [];
        } catch (e) {
          return [];
        }
      },

      saveWishlist: function(wishlist) {
        try {
          localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
          window.dispatchEvent(new CustomEvent('tp-wishlist-updated', { detail: wishlist }));
        } catch (e) {
          console.warn('TP Wishlist: Could not save to localStorage');
        }
      },

      isInWishlist: function(productId) {
        var wishlist = this.getWishlist();
        return wishlist.some(function(item) {
          return String(item.id) === String(productId);
        });
      },

      getWishlistCount: function() {
        return this.getWishlist().length;
      },

      addProduct: function(productData) {
        var wishlist = this.getWishlist();
        var exists = wishlist.some(function(item) {
          return String(item.id) === String(productData.id);
        });
        if (!exists) {
          wishlist.push(productData);
          this.saveWishlist(wishlist);
          return true;
        }
        return false;
      },

      removeProduct: function(productId) {
        var wishlist = this.getWishlist();
        var filtered = wishlist.filter(function(item) {
          return String(item.id) !== String(productId);
        });
        if (filtered.length !== wishlist.length) {
          this.saveWishlist(filtered);
          return true;
        }
        return false;
      },

      updateWishlistCount: function() {
        var count = this.getWishlistCount();
        var badge = document.getElementById('tp-header-wishlist-badge');
        if (badge) {
          if (count > 0) {
            badge.textContent = count;
            badge.classList.add('is-visible');
          } else {
            badge.textContent = '';
            badge.classList.remove('is-visible');
          }
          badge.classList.remove('is-pulse');
          void badge.offsetWidth;
          badge.classList.add('is-pulse');
        }
        return count;
      },

      showWishlistToast: function(type, productName) {
        var container = document.getElementById('tp-toast-container');
        if (!container) return;

        var toast = document.createElement('div');
        toast.className = 'tp-toast';
        toast.setAttribute('role', 'status');

        var iconClass = type === 'add' ? 'tp-toast__icon--add' : 'tp-toast__icon--remove';
        var iconSvg = type === 'add'
          ? '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
          : '<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';

        var message = type === 'add'
          ? '<span class="tp-toast__text"><span class="tp-toast__product-name">' + (productName || 'Product') + '</span> added to wishlist</span>'
          : '<span class="tp-toast__text"><span class="tp-toast__product-name">' + (productName || 'Product') + '</span> removed from wishlist</span>';

        toast.innerHTML =
          '<span class="tp-toast__icon ' + iconClass + '">' + iconSvg + '</span>' +
          message;

        container.appendChild(toast);

        requestAnimationFrame(function() {
          toast.classList.add('is-visible');
        });

        setTimeout(function() {
          toast.classList.add('is-hiding');
          toast.classList.remove('is-visible');
          setTimeout(function() {
            if (toast.parentNode) {
              toast.parentNode.removeChild(toast);
            }
          }, 200);
        }, 2500);
      },

      toggleProduct: function(btn) {
        var card = btn.closest('.tp-product-card') || btn.closest('.tp-wishlist-card');
        if (!card || card.classList.contains('tp-product-card--placeholder')) return;

        var productId = card.dataset.productId || btn.dataset.productId;
        if (!productId) return;

        var isActive = btn.classList.contains('is-active');
        var productName = card.dataset.wishlistTitle || btn.dataset.wishlistTitle || '';

        if (isActive) {
          this.removeProduct(productId);
          btn.classList.remove('is-active');
          this.showWishlistToast('remove', productName);
        } else {
          var productData = {
            id: productId,
            title: card.dataset.wishlistTitle || '',
            price: card.dataset.wishlistPrice || '',
            image: card.dataset.wishlistImage || '',
            url: card.dataset.wishlistUrl || '',
            addedAt: new Date().toISOString()
          };
          this.addProduct(productData);
          btn.classList.add('is-active');
          this.showWishlistToast('add', productName);
        }

        this.updateWishlistCount();
      },

      initButtons: function() {
        var self = this;
        var wishlist = this.getWishlist();
        var wishlistIds = wishlist.map(function(item) { return String(item.id); });

        document.querySelectorAll('.tp-wishlist-btn').forEach(function(btn) {
          var card = btn.closest('.tp-product-card') || btn.closest('.tp-wishlist-card');
          if (!card || card.classList.contains('tp-product-card--placeholder')) return;

          var productId = card.dataset.productId || btn.dataset.productId;
          if (productId && wishlistIds.indexOf(String(productId)) !== -1) {
            btn.classList.add('is-active');
          } else {
            btn.classList.remove('is-active');
          }
        });

        this.updateWishlistCount();
      },

      renderWishlistPage: function() {
        var wishlist = this.getWishlist();
        var grid = document.getElementById('tp-wishlist-grid');
        var empty = document.getElementById('tp-wishlist-empty');

        if (!grid || !empty) return;

        if (wishlist.length === 0) {
          grid.style.display = 'none';
          empty.style.display = 'block';
          return;
        }

        grid.style.display = 'grid';
        empty.style.display = 'none';

        grid.innerHTML = wishlist.map(function(item) {
          var imageHtml;
          if (item.image) {
            imageHtml = '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">';
          } else {
            imageHtml = '<div class="tp-wishlist-card__image-placeholder">' + (item.title.charAt(0) || '?') + '</div>';
          }

          return '<a href="' + (item.url || '#') + '" class="tp-wishlist-card" data-product-id="' + item.id + '" data-wishlist-title="' + (item.title || '') + '" data-wishlist-price="' + (item.price || '') + '" data-wishlist-image="' + (item.image || '') + '" data-wishlist-url="' + (item.url || '') + '">' +
            '<div class="tp-wishlist-card__image">' +
              imageHtml +
              '<button class="tp-wishlist-card__wishlist tp-wishlist-btn is-active" aria-label="Remove from wishlist" data-product-id="' + item.id + '">' +
                '<svg viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                  '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
                '</svg>' +
              '</button>' +
            '</div>' +
            '<div class="tp-wishlist-card__content">' +
              '<h3 class="tp-wishlist-card__name">' + item.title + '</h3>' +
              '<p class="tp-wishlist-card__price">' + (item.price || '') + '</p>' +
            '</div>' +
          '</a>';
        }.bind(this)).join('');

      },

      init: function() {
        var self = this;
        this.initButtons();

        // Single event delegation for wishlist page remove buttons
        document.addEventListener('click', function(e) {
          var btn = e.target.closest('.tp-wishlist-card__wishlist');
          if (!btn) return;
          e.preventDefault();
          e.stopPropagation();
          var productId = btn.dataset.productId;
          var card = btn.closest('.tp-wishlist-card');
          var productName = card ? card.dataset.wishlistTitle : '';
          self.removeProduct(productId);
          self.showWishlistToast('remove', productName);
          self.updateWishlistCount();
          self.renderWishlistPage();
        });

        window.addEventListener('tp-wishlist-updated', function() {
          this.initButtons();
          this.updateWishlistCount();
          this.renderWishlistPage();
        }.bind(this));

        if (document.getElementById('tp-wishlist-page')) {
          this.renderWishlistPage();
        }
      }
    };

    window.TPWishlist = TPWishlist;
    window.getWishlist = function() { return TPWishlist.getWishlist(); };
    window.saveWishlist = function(data) { return TPWishlist.saveWishlist(data); };
    window.updateWishlistCount = function() { return TPWishlist.updateWishlistCount(); };
    window.showWishlistToast = function(type, name) { return TPWishlist.showWishlistToast(type, name); };
    window.toggleWishlist = function(btn) { return TPWishlist.toggleProduct(btn); };
    window.TPWishlistToggle = function(btn) { return TPWishlist.toggleProduct(btn); };

    function initWishlist() {
      TPWishlist.init();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWishlist);
    } else {
      initWishlist();
    }

    function isThemeEditor() {
      return typeof Shopify !== 'undefined' && Shopify.designMode === true;
    }

    document.addEventListener('shopify:section:load', function(e) {
      setTimeout(function() {
        if (TPWishlist && TPWishlist.initButtons) {
          TPWishlist.initButtons();
        }
        if (TPWishlist && TPWishlist.renderWishlistPage) {
          TPWishlist.renderWishlistPage();
        }
      }, 100);
    });

    document.addEventListener('shopify:section:unload', function(e) {});

    if (isThemeEditor()) {
      console.log('TP Wishlist: Theme Editor mode active');
      var originalShowToast = TPWishlist.showWishlistToast.bind(TPWishlist);
      TPWishlist.showWishlistToast = function(type, productName) {
        if (document.getElementById('tp-toast-container')) {
          originalShowToast(type, productName);
        }
      };
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newcatogries"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  class TPCategories {
    constructor(el) {
      this.el = el;
      this.dotsContainer = el.querySelector('#tp-cat-dots');
      this.progress = el.querySelector('#tp-cat-progress');
      this.prevBtn = el.querySelector('#tp-cat-prev');
      this.nextBtn = el.querySelector('#tp-cat-next');

      // Mobile elements
      this.mobileTrack = el.querySelector('#tp-cat-track');
      this.mobileWrapper = el.querySelector('#tp-cat-mobile-wrapper');

      // Desktop elements
      this.desktopWrapper = el.querySelector('#tp-cat-desktop-wrapper');
      this.desktopTrack = el.querySelector('#tp-cat-track-desktop');
      this.trackWrapper = el.querySelector('#tp-cat-track-wrapper');

      if (!this.mobileTrack && !this.desktopTrack) return;

      this.autoplay = el.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(el.dataset.autoplaySpeed) || 5000;
      this.isPaused = false;
      this.autoplayTimer = null;

      // State
      this.currentIndex = 0;
      this.cardWidth = 0;
      this.gapWidth = 24;
      this.currentScroll = 0;
      this.maxScroll = 0;
      this.isDragging = false;
      this.dots = [];
      this.cards = [];

      // Detect mobile
      this.isMobile = window.matchMedia('(max-width: 768px)').matches;

      this.init();
    }

    init() {
      this.setupResponsive();
      this.bindEvents();

      // Listen for viewport changes
      this.mediaQuery = window.matchMedia('(max-width: 768px)');
      this.mediaQuery.addEventListener('change', (e) => this.onBreakpointChange(e));
    }

    setupResponsive() {
      if (this.isMobile) {
        this.setupMobile();
      } else {
        this.setupDesktop();
      }
    }

    setupMobile() {
      // Get cards from mobile track
      this.cards = Array.from(this.mobileTrack.querySelectorAll('.tp-cat-card'));
      if (this.cards.length === 0) return;

      // Build dots
      this.buildMobileDots();
      this.updateActiveDot(0);

      // Initial scroll position
      requestAnimationFrame(() => {
        this.updateActiveDotFromScroll();
      });
    }

    setupDesktop() {
      // Get cards from desktop track
      this.cards = Array.from(this.desktopTrack.querySelectorAll('.tp-cat-card'));
      if (this.cards.length === 0) return;

      // Build dots
      this.buildDesktopDots();
      this.updateDimensions();
      this.goTo(0, false);

      // Start autoplay
      if (this.autoplay) this.startAutoplay();
    }

    buildMobileDots() {
      this.dotsContainer.innerHTML = '';
      this.dots = [];

      this.cards.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'tp-categories__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to card ' + (i + 1));
        dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        dot.addEventListener('click', () => this.scrollToCard(i));
        this.dotsContainer.appendChild(dot);
        this.dots.push(dot);
      });
    }

    buildDesktopDots() {
      this.dotsContainer.innerHTML = '';
      this.dots = [];

      const visibleCount = this.getVisibleCount();
      const pageCount = Math.ceil(this.cards.length / visibleCount);

      for (let i = 0; i < pageCount; i++) {
        const dot = document.createElement('button');
        dot.className = 'tp-categories__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        dot.addEventListener('click', () => this.goToPage(i));
        this.dotsContainer.appendChild(dot);
        this.dots.push(dot);
      }
    }

    scrollToCard(index) {
      if (!this.isMobile || !this.cards[index]) return;

      const card = this.cards[index];
      const track = this.mobileTrack;
      const cardLeft = card.offsetLeft;
      const targetScroll = cardLeft - 20;

      track.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });

      this.updateActiveDot(index);
    }

    updateActiveDot(index) {
      this.dots.forEach((dot, i) => {
        const isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    updateActiveDotFromScroll() {
      if (!this.isMobile || !this.mobileTrack || this.cards.length === 0) return;

      const track = this.mobileTrack;
      const scrollLeft = track.scrollLeft;
      const trackWidth = track.offsetWidth;
      const viewportCenter = scrollLeft + (trackWidth / 2);

      let closestIndex = 0;
      let closestDistance = Infinity;

      this.cards.forEach((card, i) => {
        const cardCenter = card.offsetLeft + (card.offsetWidth / 2);
        const distance = Math.abs(cardCenter - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });

      if (closestIndex !== this.currentIndex) {
        this.currentIndex = closestIndex;
        this.updateActiveDot(closestIndex);
      }
    }

    getVisibleCount() {
      if (this.cards.length === 0) return 1;
      const containerWidth = this.trackWrapper.offsetWidth;
      const cardW = this.cards[0].offsetWidth + this.gapWidth;
      return Math.max(1, Math.floor(containerWidth / cardW));
    }

    updateDimensions() {
      if (this.cards.length === 0) return;
      this.gapWidth = window.innerWidth <= 640 ? 16 : 24;
      const firstCard = this.cards[0];
      this.cardWidth = firstCard.offsetWidth + this.gapWidth;
      const visibleCount = this.getVisibleCount();
      this.maxScroll = this.cardWidth * (this.cards.length - visibleCount);
    }

    getScrollForIndex(index) {
      const visibleCount = this.getVisibleCount();
      const pageIndex = Math.floor(index / visibleCount);
      const scrollPerPage = this.cardWidth * visibleCount;
      return Math.max(0, pageIndex * scrollPerPage);
    }

    getIndexFromScroll(scroll) {
      const visibleCount = this.getVisibleCount();
      const pageIndex = Math.floor(scroll / (this.cardWidth * visibleCount));
      return Math.min(pageIndex * visibleCount, this.cards.length - 1);
    }

    goToPage(pageIndex) {
      if (this.isMobile) return;
      const visibleCount = this.getVisibleCount();
      const targetIndex = pageIndex * visibleCount;
      this.goTo(targetIndex, true);
    }

    goTo(index, animate) {
      if (this.isMobile) return;

      animate = animate !== undefined ? animate : true;
      if (index < 0) index = 0;
      if (index >= this.cards.length) index = this.cards.length - 1;
      this.currentIndex = index;

      const scroll = this.getScrollForIndex(index);
      if (!animate) {
        this.desktopTrack.style.transition = 'none';
      } else {
        this.desktopTrack.style.transition = '';
      }
      this.desktopTrack.style.transform = 'translateX(-' + scroll + 'px)';
      this.currentScroll = scroll;

      const visibleCount = this.getVisibleCount();
      const activePage = Math.floor(scroll / (this.cardWidth * visibleCount));
      this.dots.forEach((dot, i) => {
        const isActive = i === activePage;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (this.prevBtn) this.prevBtn.disabled = scroll <= 0;
      if (this.nextBtn) this.nextBtn.disabled = scroll >= this.maxScroll;

      if (this.autoplay) this.resetAutoplay();
      if (animate && this.autoplay) this.startProgress();
    }

    prev() {
      if (this.isMobile) return;
      const visibleCount = this.getVisibleCount();
      this.goTo(Math.max(0, this.currentIndex - visibleCount));
    }

    next() {
      if (this.isMobile) return;
      const visibleCount = this.getVisibleCount();
      this.goTo(Math.min(this.cards.length - 1, this.currentIndex + visibleCount));
    }

    startAutoplay() {
      if (this.isMobile) return;
      this.stopAutoplay();
      this.isPaused = false;
      if (this.progress) this.progress.classList.add('is-visible');
      if (this.autoplaySpeed <= 0) return;
      this.autoplayTimer = setTimeout(() => {
        if (this.currentIndex >= this.cards.length - 1) {
          this.goTo(0);
        } else {
          this.next();
        }
        this.startAutoplay();
      }, this.autoplaySpeed);
      this.startProgress();
    }

    stopAutoplay() {
      clearTimeout(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    startProgress() {
      if (!this.progress || this.isMobile) return;
      this.progress.style.transition = 'none';
      this.progress.style.width = '0%';
      requestAnimationFrame(() => {
        this.progress.style.transition = 'width ' + this.autoplaySpeed + 'ms linear';
        this.progress.style.width = '100%';
      });
    }

    onBreakpointChange(e) {
      const wasMobile = this.isMobile;
      this.isMobile = e.matches;

      this.setupResponsive();
    }

    bindEvents() {
      // Desktop navigation
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

      // Mobile: Only scroll listener for dot updates — no custom touch handling
      // Browser handles all touch gestures natively
      if (this.isMobile && this.mobileTrack) {
        this.mobileTrack.addEventListener('scroll', () => {
          requestAnimationFrame(() => this.updateActiveDotFromScroll());
        }, { passive: true });
      }

      // Desktop mouse drag
      if (!this.isMobile) {
        this.trackWrapper.addEventListener('mousedown', (e) => this.onDragStart(e));
        document.addEventListener('mousemove', (e) => this.onDragMove(e));
        document.addEventListener('mouseup', (e) => this.onDragEnd(e));
      }

      // Resize handler
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.updateDimensions();
          if (this.isMobile) {
            this.buildMobileDots();
            this.updateActiveDotFromScroll();
          } else {
            this.buildDesktopDots();
            this.goTo(Math.min(this.currentIndex, this.cards.length - 1), false);
          }
        }, 150);
      });

      // Autoplay pause on hover
      this.el.addEventListener('mouseenter', () => {
        if (this.autoplay && !this.isPaused && !this.isMobile) {
          this.isPaused = true;
          this.stopAutoplay();
        }
      });
      this.el.addEventListener('mouseleave', () => {
        if (this.autoplay && this.isPaused && !this.isMobile) {
          this.isPaused = false;
          this.startAutoplay();
        }
      });

      // Keyboard navigation
      this.el.addEventListener('keydown', (e) => {
        if (this.isMobile) {
          if (e.key === 'ArrowLeft') this.scrollToCard(Math.max(0, this.currentIndex - 1));
          if (e.key === 'ArrowRight') this.scrollToCard(Math.min(this.cards.length - 1, this.currentIndex + 1));
        } else {
          if (e.key === 'ArrowLeft') this.prev();
          if (e.key === 'ArrowRight') this.next();
        }
      });
    }

    onDragStart(e) {
      if (this.isMobile) return;
      if (e.target.closest('.tp-cat-card')) return;
      e.preventDefault();

      this.dragStartX = e.clientX;
      this.currentScroll = this.desktopTrack.style.transform
        ? parseFloat(this.desktopTrack.style.transform.replace('translateX(', '').replace('px)', '')) || 0
        : 0;
      this.isDragging = false;
      this.desktopTrack.classList.add('is-dragging');
      this.desktopTrack.style.transition = 'none';
    }

    onDragMove(e) {
      if (this.isMobile) return;
      if (!this.desktopTrack.classList.contains('is-dragging')) return;

      const diff = this.dragStartX - e.clientX;
      if (Math.abs(diff) > 5) this.isDragging = true;
      if (!this.isDragging) return;

      const newScroll = Math.max(0, Math.min(this.maxScroll, this.currentScroll + diff));
      this.desktopTrack.style.transform = 'translateX(-' + newScroll + 'px)';
    }

    onDragEnd(e) {
      if (this.isMobile) return;
      if (!this.desktopTrack.classList.contains('is-dragging')) return;
      this.desktopTrack.classList.remove('is-dragging');

      const diff = this.dragStartX - e.clientX;
      const currentScroll = parseFloat(this.desktopTrack.style.transform.replace('translateX(', '').replace('px)', '')) || 0;
      const threshold = Math.min(50, this.cardWidth * 0.25);

      if (Math.abs(diff) > threshold) {
        if (diff > 0) this.next();
        else this.prev();
      } else {
        this.goTo(this.getIndexFromScroll(currentScroll));
      }

      this.isDragging = false;
    }
  }

  function initCategories() {
    document.querySelectorAll('.tp-categories').forEach(el => {
      if (!el.dataset.initialized) {
        new TPCategories(el);
        el.dataset.initialized = 'true';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategories);
  } else {
    initCategories();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newfeaturecollection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════════════
     THEME EDITOR COMPATIBILITY
     Handle Shopify.designMode and section reloading
     ═══════════════════════════════════════════════════════════════ */
  var TPConfig = {
    isInitialized: false,
    initFlags: {
      carousel: false,
      wishlist: false
    },
    // Event handler storage for cleanup
    boundHandlers: []
  };

  /* ── Check if in Theme Editor ── */
  function isThemeEditor() {
    return typeof Shopify !== 'undefined' && Shopify.designMode === true;
  }

  /* ── Clean up existing handlers before re-initialization ── */
  function cleanupHandlers() {
    TPConfig.boundHandlers.forEach(function(handler) {
      if (handler.element && handler.type) {
        handler.element.removeEventListener(handler.type, handler.fn);
      }
    });
    TPConfig.boundHandlers = [];
  }

  /* ── Store handler reference for cleanup ── */
  function bindHandler(element, type, fn) {
    TPConfig.boundHandlers.push({ element: element, type: type, fn: fn });
    element.addEventListener(type, fn);
  }

  /* ── Desktop Featured Carousel ── */
  function initFeaturedCarousel() {
    // Skip if already initialized (prevent duplicate init)
    if (TPConfig.initFlags.carousel) return;
    TPConfig.initFlags.carousel = true;

    var sections = document.querySelectorAll('.tp-featured');

    sections.forEach(function(section) {
      // Skip if this specific section already initialized
      if (section.dataset.carouselInit === 'true') return;

      var track = section.querySelector('#tp-feat-track');
      var trackWrapper = section.querySelector('#tp-feat-track-wrapper');
      var dotsContainer = section.querySelector('#tp-feat-dots');
      var prevBtn = section.querySelector('#tp-feat-prev');
      var nextBtn = section.querySelector('#tp-feat-next');
      var cards = track ? Array.from(track.querySelectorAll('.tp-product-card')) : [];

      if (!track || cards.length === 0) return;

      var state = {
        currentIndex: 0,
        cardWidth: 0,
        gap: 24,
        visibleCount: 3,
        maxIndex: 0,
        isAnimating: false
      };

      /* ── Calculate slide width ── */
      function updateSlideWidth() {
        if (cards.length === 0) return;

        var computedStyle = window.getComputedStyle(track);
        state.gap = parseInt(computedStyle.gap) || 24;

        var firstCard = cards[0];
        state.cardWidth = firstCard.offsetWidth + state.gap;

        var wrapperWidth = trackWrapper.offsetWidth;
        state.visibleCount = Math.floor(wrapperWidth / state.cardWidth);
        state.visibleCount = Math.max(1, Math.min(state.visibleCount, cards.length));

        state.maxIndex = Math.max(0, cards.length - state.visibleCount);
      }

      /* ── Update transform ── */
      function updateSlider() {
        if (state.isAnimating) return;
        state.isAnimating = true;

        var translateX = state.currentIndex * state.cardWidth;
        track.style.transition = 'transform 500ms cubic-bezier(0, 0, 0.2, 1)';
        track.style.transform = 'translateX(-' + translateX + 'px)';

        if (dotsContainer) {
          var activePage = Math.floor(state.currentIndex / state.visibleCount);
          var dots = dotsContainer.querySelectorAll('.tp-featured__dot');
          dots.forEach(function(dot, i) {
            dot.classList.toggle('is-active', i === activePage);
            dot.setAttribute('aria-selected', i === activePage ? 'true' : 'false');
          });
        }

        if (prevBtn) prevBtn.disabled = state.currentIndex <= 0;
        if (nextBtn) nextBtn.disabled = state.currentIndex >= state.maxIndex;

        setTimeout(function() { state.isAnimating = false; }, 500);
      }

      /* ── Build dots ── */
      function buildDots() {
        if (!dotsContainer) return;

        dotsContainer.innerHTML = '';

        var pageCount = Math.ceil(cards.length / state.visibleCount);
        pageCount = Math.max(1, pageCount);

        for (var i = 0; i < pageCount; i++) {
          var dot = document.createElement('button');
          dot.className = 'tp-featured__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
          dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');

          (function(pageIndex) {
            var dotHandler = function() {
              state.currentIndex = pageIndex * state.visibleCount;
              state.currentIndex = Math.min(state.currentIndex, state.maxIndex);
              updateSlider();
            };
            bindHandler(dot, 'click', dotHandler);
          })(i);

          dotsContainer.appendChild(dot);
        }
      }

      /* ── Arrow handlers ── */
      function nextSlide() {
        state.currentIndex = Math.min(state.currentIndex + state.visibleCount, state.maxIndex);
        updateSlider();
      }

      function prevSlide() {
        state.currentIndex = Math.max(state.currentIndex - state.visibleCount, 0);
        updateSlider();
      }

      /* ── Event listeners ── */
      if (prevBtn) bindHandler(prevBtn, 'click', prevSlide);
      if (nextBtn) bindHandler(nextBtn, 'click', nextSlide);

      /* ── Drag support ── */
      var isDragging = false;
      var dragStartX = 0;
      var dragStartIndex = 0;

      var mouseDownHandler = function(e) {
        if (e.target.closest('.tp-product-card')) return;
        isDragging = true;
        dragStartX = e.clientX;
        dragStartIndex = state.currentIndex;
        track.style.transition = 'none';
        track.style.cursor = 'grabbing';
      };
      bindHandler(trackWrapper, 'mousedown', mouseDownHandler);

      var mouseMoveHandler = function(e) {
        if (!isDragging) return;
        var diff = dragStartX - e.clientX;
        var diffInCards = Math.round(diff / state.cardWidth);
        state.currentIndex = Math.max(0, Math.min(state.maxIndex, dragStartIndex + diffInCards));
        var translateX = state.currentIndex * state.cardWidth;
        track.style.transform = 'translateX(-' + translateX + 'px)';
      };
      bindHandler(document, 'mousemove', mouseMoveHandler);

      var mouseUpHandler = function() {
        if (!isDragging) return;
        isDragging = false;
        track.style.cursor = '';
        updateSlider();
      };
      bindHandler(document, 'mouseup', mouseUpHandler);

      /* ── Resize handler ── */
      var resizeTimer;
      var resizeHandler = function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          updateSlideWidth();
          state.currentIndex = Math.min(state.currentIndex, state.maxIndex);
          buildDots();
          track.style.transition = 'none';
          track.style.transform = 'translateX(-' + (state.currentIndex * state.cardWidth) + 'px)';
          updateSlider();
        }, 100);
      };
      bindHandler(window, 'resize', resizeHandler);

      /* ── Keyboard navigation ── */
      var keyHandler = function(e) {
        if (e.key === 'ArrowLeft') prevSlide();
        if (e.key === 'ArrowRight') nextSlide();
      };
      bindHandler(section, 'keydown', keyHandler);

      /* ── Initialize ── */
      requestAnimationFrame(function() {
        updateSlideWidth();
        buildDots();
        updateSlider();
      });

      section.dataset.carouselInit = 'true';
    });
  }

  /* ── Initialize on load ── */
  function onDOMReady() {
    if (!TPConfig.isInitialized) {
      TPConfig.isInitialized = true;
      initFeaturedCarousel();
      initWishlist();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onDOMReady);
  } else {
    onDOMReady();
  }

  /* ═══════════════════════════════════════════════════════════════
     ADD TO CART - With Theme Editor safeguards
     ═══════════════════════════════════════════════════════════════ */
  var TPAddToCartInProgress = new WeakSet();

  async function TPAddToCart(btn) {
    // Prevent duplicate calls on same button
    if (TPAddToCartInProgress.has(btn)) return;
    TPAddToCartInProgress.add(btn);

    var variantId = btn.dataset.variantId;
    var productId = btn.dataset.productId;
    var productTitle = btn.dataset.productTitle || 'Product';

    // Check if button is disabled (sold out)
    if (btn.classList.contains('tp-is-disabled') || btn.disabled) {
      // In Theme Editor, don't show error toast for disabled buttons
      if (!isThemeEditor()) {
        TPShowCartToast('This product is sold out', 'error');
      }
      TPAddToCartInProgress.delete(btn);
      return;
    }

    // Validate variant ID
    var isValidVariantId = variantId &&
                          variantId !== 'undefined' &&
                          variantId !== 'null' &&
                          variantId !== '' &&
                          !isNaN(parseInt(variantId, 10));

    if (!isValidVariantId) {
      console.warn('TP Add to Cart: Invalid variant ID', productId, variantId);
      if (productId) {
        TPAddToCartByProductId(productId, btn);
      } else if (!isThemeEditor()) {
        TPShowCartToast('Could not find product variant', 'error');
      }
      TPAddToCartInProgress.delete(btn);
      return;
    }

    // Prevent double-click
    if (btn.classList.contains('tp-is-loading')) {
      TPAddToCartInProgress.delete(btn);
      return;
    }
    btn.classList.add('tp-is-loading');

    var icon = btn.querySelector('.tp-add-icon');
    var spinner = btn.querySelector('.tp-add-spinner');
    if (icon) icon.style.display = 'none';
    if (spinner) spinner.style.display = 'block';

    try {
      var variantIdInt = parseInt(variantId, 10);

      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantIdInt, quantity: 1 })
      });

      var data = await response.json();

      if (!response.ok) {
        var errorMsg = data.description || data.message || 'Could not add to cart';

        // Only update button state in live storefront, not Theme Editor
        if (!isThemeEditor()) {
          if (errorMsg.toLowerCase().includes('sold') ||
              errorMsg.toLowerCase().includes('unavailable') ||
              errorMsg.toLowerCase().includes('quantity') ||
              response.status === 422) {
            btn.classList.add('tp-is-disabled');
            btn.disabled = true;
            errorMsg = 'This product is sold out';
          }
        }

        throw new Error(errorMsg);
      }

      // Success - update UI
      await TPRefreshCartCount();
      TPRefreshCartDrawer();
      TPShowCartToast(productTitle + ' added to cart', 'success');

      btn.classList.add('tp-is-success');
      if (icon) {
        icon.style.display = 'block';
        icon.innerHTML = '<polyline points="20 6 9 17 4 12" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>';
      }
      if (spinner) spinner.style.display = 'none';

      setTimeout(function() {
        btn.classList.remove('tp-is-success');
        if (icon) {
          icon.style.display = 'block';
          icon.innerHTML = '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>';
        }
      }, 2000);

    } catch (err) {
      console.error('TP Add to Cart Error:', err);
      if (icon) icon.style.display = 'block';
      if (spinner) spinner.style.display = 'none';
      btn.classList.remove('tp-is-loading');
      if (!isThemeEditor()) {
        TPShowCartToast(err.message || 'Could not add to cart', 'error');
      }
    }

    btn.classList.remove('tp-is-loading');
    TPAddToCartInProgress.delete(btn);
  }

  /* ── Get variant by product ID ── */
  async function TPAddToCartByProductId(productId, btn) {
    try {
      var response = await fetch('/products/' + productId + '.js');
      if (!response.ok) throw new Error('Product not found');

      var product = await response.json();
      if (product.variants && product.variants.length > 0) {
        var selectedVariant = null;

        if (product.selected_variant) {
          selectedVariant = product.variants.find(function(v) { return v.id === product.selected_variant.id; });
        }

        if (!selectedVariant || !selectedVariant.available) {
          selectedVariant = product.variants.find(function(v) { return v.available; });
        }

        if (!selectedVariant) selectedVariant = product.variants[0];

        if (selectedVariant) {
          btn.dataset.variantId = selectedVariant.id;
          if (!selectedVariant.available) {
            btn.classList.add('tp-is-disabled');
            btn.disabled = true;
            if (!isThemeEditor()) {
              TPShowCartToast('This variant is sold out', 'error');
            }
            return;
          }
          TPAddToCart(btn);
        } else {
          if (!isThemeEditor()) {
            TPShowCartToast('No variants available', 'error');
          }
        }
      } else {
        if (!isThemeEditor()) {
          TPShowCartToast('Could not load product variants', 'error');
        }
      }
    } catch (err) {
      console.error('TP Get Product Error:', err);
      if (!isThemeEditor()) {
        TPShowCartToast('Could not find product', 'error');
      }
    }
  }

  /* ── Refresh Cart Count ── */
  async function TPRefreshCartCount() {
    try {
      var cartRes = await fetch('/cart.js', { credentials: 'include' });
      if (!cartRes.ok) throw new Error('Cart fetch failed');

      var cart = await cartRes.json();
      var count = cart.item_count;

      var cartBubble = document.querySelector('.cart-count-bubble');
      if (cartBubble) {
        var countEl = cartBubble.querySelector('[data-cart-count]');
        if (countEl) countEl.textContent = count;
        cartBubble.style.display = count > 0 ? 'flex' : 'none';
        cartBubble.style.transform = 'scale(1.3)';
        setTimeout(function() { cartBubble.style.transform = ''; }, 300);
      }

      TPRefreshCartDrawer();
      window.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));

      return cart;

    } catch (err) {
      console.warn('TPRefreshCartCount failed:', err);
      return null;
    }
  }

  /* ── Refresh Cart Drawer ── */
  function TPRefreshCartDrawer() {
    fetch('/cart.js', { credentials: 'include' })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        window.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));

        var drawer = document.querySelector('cart-drawer');
        var notification = document.querySelector('cart-notification');

        if (drawer) {
          if (typeof drawer.open === 'function') drawer.open();
          if (typeof drawer.renderContents === 'function') drawer.renderContents(cart);
        }

        if (notification) {
          if (typeof notification.open === 'function') notification.open();
          if (typeof notification.renderContents === 'function') notification.renderContents(cart);
        }
      })
      .catch(function(err) {
        console.warn('Cart refresh error:', err);
      });
  }

  /* ── Show Cart Toast ── */
  function TPShowCartToast(message, type) {
    type = type || 'success';
    var toast = document.getElementById('tp-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'tp-cart-toast';
      toast.className = 'tp-wishlist-toast';
      document.body.appendChild(toast);
    }

    var iconSvg = type === 'success'
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>';

    toast.className = 'tp-wishlist-toast' + (type === 'error' ? ' tp-wishlist-toast--error' : '');
    toast.innerHTML = iconSvg + '<span>' + message + '</span>';

    requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });

    clearTimeout(window.tpCartToastTimeout);
    window.tpCartToastTimeout = setTimeout(function() {
      toast.classList.remove('is-visible');
    }, 2500);
  }

  window.TPAddToCart = TPAddToCart;
  window.TPRefreshCartCount = TPRefreshCartCount;

  /* ═══════════════════════════════════════════════════════════════
     WISHLIST MANAGER
     ═══════════════════════════════════════════════════════════════ */
  function initWishlistToast() {
    if (!document.getElementById('tp-wishlist-toast')) {
      var toast = document.createElement('div');
      toast.id = 'tp-wishlist-toast';
      toast.className = 'tp-wishlist-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
  }

  function initWishlistButtons() {
    if (typeof TPWishlist !== 'undefined' && TPWishlist.initButtons) {
      TPWishlist.initButtons();
    }
  }

  function toggleWishlist(btn) {
    var card = btn.closest('.tp-product-card');
    if (!card || card.classList.contains('tp-product-card--placeholder')) return;

    if (typeof TPWishlist !== 'undefined' && TPWishlist.toggleProduct) {
      TPWishlist.toggleProduct(btn);
      return;
    }

    var productId = card.dataset.productId || btn.dataset.productId;
    if (!productId) return;

    try {
      var wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
      var isActive = btn.classList.contains('is-active');

      if (isActive) {
        wishlist = wishlist.filter(function(item) {
          return String(item.id) !== String(productId);
        });
        btn.classList.remove('is-active');
      } else {
        var exists = wishlist.some(function(item) {
          return String(item.id) === String(productId);
        });
        if (!exists) {
          wishlist.push({
            id: productId,
            title: card.dataset.wishlistTitle || '',
            price: card.dataset.wishlistPrice || '',
            image: card.dataset.wishlistImage || '',
            url: card.dataset.wishlistUrl || '',
            addedAt: new Date().toISOString()
          });
          btn.classList.add('is-active');
        }
      }

      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      window.dispatchEvent(new CustomEvent('tp-wishlist-updated', { detail: wishlist }));

    } catch (e) {
      console.warn('TP Wishlist Error:', e);
    }
  }

  function initWishlist() {
    // Prevent duplicate init
    if (TPConfig.initFlags.wishlist) return;
    TPConfig.initFlags.wishlist = true;

    initWishlistToast();

    if (typeof TPWishlist !== 'undefined' && TPWishlist.initButtons) {
      TPWishlist.initButtons();
    } else {
      setTimeout(function() {
        if (typeof TPWishlist !== 'undefined' && TPWishlist.initButtons) {
          TPWishlist.initButtons();
        } else {
          var wishlist = [];
          try {
            wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
          } catch (e) {}
          var wishlistIds = wishlist.map(function(item) { return String(item.id); });

          document.querySelectorAll('.tp-wishlist-btn').forEach(function(btn) {
            var card = btn.closest('.tp-product-card');
            if (!card || card.classList.contains('tp-product-card--placeholder')) return;
            var productId = card.dataset.productId || btn.dataset.productId;
            if (productId && wishlistIds.indexOf(String(productId)) !== -1) {
              btn.classList.add('is-active');
            } else {
              btn.classList.remove('is-active');
            }
          });
        }
      }, 100);
    }
  }

  window.TPWishlistToggle = toggleWishlist;

  /* ── Wishlist updates listener ── */
  bindHandler(window, 'tp-wishlist-updated', function() {
    initWishlistButtons();
  });

  /* ═══════════════════════════════════════════════════════════════
     THEME EDITOR EVENT HANDLERS
     Properly handle section reloads in Shopify Theme Editor
     ═══════════════════════════════════════════════════════════════ */

  /* ── Section load/unload events ── */
  document.addEventListener('shopify:section:load', function(e) {
    // Reset init flags for the loaded section
    var sectionEl = e.target;
    if (sectionEl && sectionEl.querySelector('.tp-featured')) {
      sectionEl.querySelectorAll('.tp-featured').forEach(function(section) {
        section.dataset.carouselInit = 'false';
      });
      // Reinitialize carousel for this section
      setTimeout(function() {
        TPConfig.initFlags.carousel = false;
        initFeaturedCarousel();
        initWishlistButtons();
      }, 50);
    }
  });

  document.addEventListener('shopify:section:unload', function(e) {
    // Clean up handlers for unloaded section
    var sectionEl = e.target;
    if (sectionEl && sectionEl.querySelector('.tp-featured')) {
      sectionEl.querySelectorAll('.tp-featured').forEach(function(section) {
        section.dataset.carouselInit = 'false';
      });
    }
  });

  /* ── Handle section reorder (changes in Theme Editor) ── */
  document.addEventListener('shopify:section:reorder', function(e) {
    // Full cleanup and reinit
    cleanupHandlers();
    TPConfig.initFlags.carousel = false;
    TPConfig.initFlags.wishlist = false;
    TPConfig.isInitialized = false;
    setTimeout(function() {
      onDOMReady();
    }, 100);
  });

  /* ── Theme Editor specific: prevent cart actions that cause confusion ── */
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    // In Theme Editor, add-to-cart should work but not show error toasts
    // This lets merchants test the UI without cart errors
    console.log('TP: Theme Editor mode - cart actions will not show error toasts');
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newfooter"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Mobile Accordion ── */
  document.querySelectorAll('.tp-footer__mobile-accordion-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var accordion = btn.closest('.tp-footer__mobile-accordion');
      var isOpen = accordion.classList.contains('is-open');

      // Close all
      document.querySelectorAll('.tp-footer__mobile-accordion').forEach(function (acc) {
        acc.classList.remove('is-open');
        acc.querySelector('.tp-footer__mobile-accordion-btn').setAttribute('aria-expanded', 'false');
      });

      // Toggle current
      if (!isOpen) {
        accordion.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Scroll to Top ── */
  var scrollBtn = document.getElementById('tp-footer-scroll-top');
  if (scrollBtn) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 400) {
        scrollBtn.classList.add('is-visible');
      } else {
        scrollBtn.classList.remove('is-visible');
      }
    }, { passive: true });

    scrollBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ── Newsletter Success Message ── */
  var form = document.getElementById('footer-newsletter');
  if (form) {
    form.addEventListener('submit', function () {
      setTimeout(function () {
        var success = document.getElementById('footer-newsletter-success');
        if (success) {
          success.style.display = 'block';
          form.style.display = 'none';
        }
      }, 500);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initWishlistPage() {
    // Wait for TPWishlist to be available (loaded from header.liquid)
    if (typeof TPWishlist === 'undefined') {
      setTimeout(initWishlistPage, 50);
      return;
    }

    // Render wishlist page using global TPWishlist
    if (document.getElementById('tp-wishlist-page')) {
      TPWishlist.renderWishlistPage();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistPage);
  } else {
    initWishlistPage();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
